<form [formGroup]="stepForm">
  <div [innerHTML]="formData.languageStepDescription | markdown" class="step-description"></div>
  <mat-form-field>
    <mat-label>{{ formData.languageControlLabel }}</mat-label>
    <mat-select formControlName="languageControl">
      @for (language of languageSelectItems; track language) {
        <mat-option [value]="language">{{ language.displayValue }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div>
    <button mat-stroked-button matStepperNext>{{ formData.buttonLabelNext }}</button>
  </div>
</form>
